import type { FlowNode } from '@lighthouse/shared'
import type { Node } from '@xyflow/react'
import { useStoreApi } from '@xyflow/react'
import { useCallback } from 'react'

import { useFlow } from '@/contexts/FlowContext'

export const useHelpline = () => {
    const store = useStoreApi()
    const workflowStore = useFlow()
    const { setHelpLineHorizontal, setHelpLineVertical } = useFlow()
    const handleSetHelpline = useCallback(
        (node: Node) => {
            const { nodes } = store.getState()

            if (node.data?.isInIteration) {
                return {
                    showHorizontalHelpLineNodes: [],
                    showVerticalHelpLineNodes: []
                }
            }
            const showHorizontalHelpLineNodes = nodes
                .filter(n => {
                    if (n.id === node.id) {
                        return false
                    }

                    if (n.data.isInIteration) {
                        return false
                    }
                    const nY = Math.ceil(n.position.y)
                    const nodeY = Math.ceil(node.position.y)

                    return !!(nY - nodeY < 5 && nY - nodeY > -5)
                })
                .sort((a, b) => a.position.x - b.position.x)

            const showHorizontalHelpLineNodesLength = showHorizontalHelpLineNodes.length
            if (showHorizontalHelpLineNodesLength > 0) {
                const first = showHorizontalHelpLineNodes[0]
                const last = showHorizontalHelpLineNodes[showHorizontalHelpLineNodesLength - 1]
                const labelWidth = last.width ?? 0
                const helpLine = {
                    top: first.position.y,
                    left: first.position.x,
                    width: last.position.x + labelWidth - first.position.x
                }

                if (node.position.x < first.position.x) {
                    const firstWidth = first.width ?? 0
                    helpLine.left = node.position.x
                    helpLine.width = first.position.x + firstWidth - node.position.x
                }

                if (node.position.x > last.position.x) {
                    const nodeWidth = node.width ?? 0
                    helpLine.width = node.position.x + nodeWidth - first.position.x
                }

                setHelpLineHorizontal?.(helpLine)
            } else {
                setHelpLineHorizontal?.()
            }

            const showVerticalHelpLineNodes = nodes
                .filter(n => {
                    if (n.id === node.id) {
                        return false
                    }
                    if (n.data.isInIteration) {
                        return false
                    }

                    const nX = Math.ceil(n.position.x)
                    const nodeX = Math.ceil(node.position.x)

                    return !!(nX - nodeX < 5 && nX - nodeX > -5)
                })
                .sort((a, b) => a.position.x - b.position.x)
            const showVerticalHelpLineNodesLength = showVerticalHelpLineNodes.length

            if (showVerticalHelpLineNodesLength > 0) {
                const first = showVerticalHelpLineNodes[0]
                const last = showVerticalHelpLineNodes[showVerticalHelpLineNodesLength - 1]
                const lastHeight = last.height ?? 0
                const helpLine = {
                    top: first.position.y,
                    left: first.position.x,
                    height: last.position.y + lastHeight - first.position.y
                }

                if (node.position.y < first.position.y) {
                    const firstHeight = first.height ?? 0
                    helpLine.top = node.position.y
                    helpLine.height = first.position.y + firstHeight - node.position.y
                }

                if (node.position.y > last.position.y) {
                    const nodeHeight = node.height ?? 0
                    helpLine.height = node.position.y + nodeHeight - first.position.y
                }

                setHelpLineVertical?.(helpLine)
            } else {
                setHelpLineVertical?.()
            }

            return {
                showHorizontalHelpLineNodes,
                showVerticalHelpLineNodes
            }
        },
        [setHelpLineHorizontal, setHelpLineVertical, store]
    )

    return {
        handleSetHelpline
    }
}
